module.exports = __webpack_public_path__ + "img/anfang-data-list-0.2797fe6a.png";